import React from 'react';
import {Row, Col} from 'react-bootstrap';

const Description = ({type}) =>{
  let main = '';
  let sub = '';

  if(type==="Coach_1"){
    // main = <span className="main">EDGE Coach와의 대화</span>;
    main = <span className="main">EDGEコーチとの初めての出会い</span>;
    // sub = <span className="sub">EDGE Premium 회원을 위한 코치가 당신을 기다리고 있습니다. 아래에서 코치를 선택해주세요.</span>
    sub = <span className="sub">EDGE Premium会員専用のコーチがあなたを待っています。以下でコーチを選択してください。</span>
  }else if(type==="Coach_2"){
    // main = <span className="main">EDGE Coach와의 대화</span>;
    main = <span className="main">EDGEコーチとの会話</span>;
    // sub = <span className="sub">뮤지오와 EDGE에 대해 궁금한 점을 코치에게 물어보세요. 여러분의 코치가 24시간 내에 답변을 드릴 것입니다.</span>
    sub = <span className="sub">MusioやEDGEに関する気になることをコーチに聞いてみてください。みなさんのコーチが順番に回答します。</span>
  }else if(type==="WrongNotes"){
    // main = <span className="main">Wrong Answer Notes</span>;
    main = <span className="main">誤答ノート</span>;
    // sub = <span className="sub">Wrong Answer Notes를 통해 Day 별 퀴즈 활동에서 틀린 내용들을 볼 수 있습니다.</span>;
    sub = <span className="sub">誤答ノートを通じて、日付別にクイズで間違った内容を確認できます。</span>;
  }else if(type==="Analysis"){
    // main = <span className="main">Study Analysis</span>;
    main = <span className="main">学習分析</span>;
    // sub = <span className="sub">Study Analysis에서는 공부한 데이터의 점수를 그래프로 확인할 수 있음</span>;
    sub = <span className="sub">学習分析では勉強した結果の点数をグラフで確認できます。</span>;
  }else if(type==="Training"){
    // main = <span className="main">Personal Training</span>;
    main = <span className="main">パーソナルトレーニング</span>;
    // sub = <span className="sub">Personal weakness를 분석하고 트레이닝 하는 세션을 자동으로 생성해줌</span>;
    sub = <span className="sub">パーソナル弱点を分析して、トレーニングセッションを自動的に生成します。</span>;
  }

  return(
      <Row className="description">
        <Col xs={8} xsOffset={2}>
          {main}
          {sub}
        </Col>
      </Row>
  );
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Pro.Description.js